<template>
  <div class="add-shop-map">
    <v-modal animation="slide-up" :minWidth="screen.breakPoint.tabLand ? '90rem' : '76rem'" :full="!screen.breakPoint.tabPort" v-model="showModal" no-padding unclosable handle-click-bg>
      <template v-slot:activator="{ on }">
        <slot name="activator" :on="on"></slot>
      </template>

      <template v-slot:default="{ containerHeight }">
        <modal-header-input @click="showModal = false" :height="headerHeight" v-model="searchQuery" @keydown:enter="geocodeAddress()" autofocus></modal-header-input>

        <transition name="fade">
          <div class="add-shop-map__list" :style="{ top: headerHeight + 'px' }" v-show="places.length > 0">
            <a @click="setPlace(place)" class="add-shop-map__list-item d-block" v-for="(place, index) of places" :key="index">{{place}}</a>
          </div>
        </transition>
        <div
          id="map"
          ref="map"
          :style="{
          width: '100%',
          height: (containerHeight - headerHeight - 2) + 'px'
        }"></div>
      </template>

      <template v-slot:footer>
        <v-button width="full" @click="saveData" :disabled="!searchQuery">{{ $t('components.Profile.addShopMap.select') }}</v-button>
      </template>
    </v-modal>
  </div>
</template>

<script>
import ModalHeaderInput from '@/ui/modals/ModalHeaderInput'
import vModal from '@/ui/modals/vModal'
import vButton from '@/ui/controls/vButton'

import screen from '@/mixins/screen'
import safeArea from '@/mixins/safeArea'

import { PlaceAutocompleteGQL } from '@/graphql/queries'

import loadGoogleMapsApi from 'load-google-maps-api'

function getInitialMapHeaderHeight () {
  return 65 + safeArea.computed.safeArea().top
}

let timeout

export default {
  name: 'Modals-mapShop',
  props: {
    value: {
      type: Object,
      default: null
    }
  },
  mixins: [screen, safeArea],
  components: {
    vModal,
    vButton,
    ModalHeaderInput
  },
  data () {
    return {
      showModal: false,
      isShow: false,
      loading: false,
      zoom: 17,
      center: null,
      map: null,
      gm: null,
      geocoder: null,
      infowindow: null,
      marker: null,
      searchQuery: null,

      markerPosition: {
        lat: null,
        lng: null
      },

      isPlaceSelected: true,
      places: [],
      headerHeight: getInitialMapHeaderHeight()
    }
  },
  computed: {
    getterGeoData () {
      return this.$store.getters.getGeoData
    },
    searchQueryCleared () {
      return this.searchQuery.replace(/\s/g, '')
    }
  },
  methods: {
    setPlace (place) {
      this.places = []
      this.isPlaceSelected = true
      this.searchQuery = place
      this.geocodeAddress()
    },
    setStartCoord () {
      if (this.value && this.value.lat && this.value.lng) {
        this.searchQuery = this.value.address || ''
        const lat = this.value.lat
        const lng = this.value.lng

        this.center = [lat, lng]

        this.markerPosition = {
          lat: lat,
          lng: lng
        }
      } else {
        if (this.$i18n.locale === 'ru') this.center = [55.75222, 37.61556]
        if (this.$i18n.locale === 'uk') this.center = [50.45466, 30.5238]
        if (this.$i18n.locale === 'kk') this.center = [51.1801000, 71.4459800]
        if (this.$i18n.locale === 'en') this.center = [55.75222, 37.61556]
        if (this.$i18n.locale === 'es') this.center = [21.17025359490436, -86.8434447870944]
        this.markerPosition = {
          lat: this.center[0],
          lng: this.center[1]
        }
      }
    },
    initMap () {
      const mapOptions = {
        center: {
          lat: this.center[0],
          lng: this.center[1]
        },
        zoom: this.zoom,
        mapTypeControl: false,
        streetViewControl: false,
        scrollwheel: false
      }
      this.map = new this.gm.Map(document.querySelector('#map'), mapOptions)
    },
    initGeocoder () {
      this.geocoder = new this.gm.Geocoder()
    },
    initInfoWindow () {
      this.infowindow = new this.gm.InfoWindow()
    },
    setMarkerData (data) {
      this.markerPosition = Object.assign({}, this.markerPosition, {
        lat: data.lat(),
        lng: data.lng()
      })
    },
    setMarker () {
      if (this.marker) this.marker.setMap(null)
      const markerOPtions = {
        map: this.map,
        position: this.markerPosition,
        draggable: true
      }
      this.marker = new this.gm.Marker(markerOPtions)
      // this.marker.addListener('click', () => { alert() })
      this.marker.setMap(this.map)
      this.setMarkerEvents()
    },
    setMarkerEvents () {
      this.marker.addListener('dragend', (q) => {
        this.map.setCenter(q.latLng)
        this.setMarkerData(q.latLng)
      })
    },
    geocodeAddress () {
      if (this.searchQueryCleared.length <= 0) return false
      this.geocoder.geocode({ address: this.searchQuery }, (results, status) => {
        if (status === 'OK') {
          this.setMarkerData(results[0].geometry.location)
          this.map.setCenter(results[0].geometry.location)
          this.setMarker()
        } else {
          console.log('Geocode was not successful for the following reason: ' + status)
        }
      })
    },
    // decodeAddress () {
    //   this.geocoder.geocode({'location': this.markerPosition}, (results, status) => {
    //     if (status === 'OK') {
    //       if (results[0]) {
    //         this.searchQuery = results[0].formatted_address
    //       } else {
    //         window.alert('No results found')
    //       }
    //     } else {
    //       window.alert('Geocoder failed due to: ' + status)
    //     }
    //   })
    // },
    initMapEvents () {
      // this.map.addListener('zoom_changed', () => {
      // })
    },
    markerToCenter () {
      const mapCenter = this.map.getCenter()
      this.markerPosition = {
        lat: mapCenter.lat(),
        lng: mapCenter.lng()
      }
      this.setMarker()
    },
    initConsrolSearchInputAndPointBtn () {
      this.map.controls[this.gm.ControlPosition.TOP_LEFT].push(document.querySelector('#map_controls .search_line'))
    },
    initControlBtnSave () {
      this.map.controls[this.gm.ControlPosition.BOTTOM_CENTER].push(document.querySelector('#map_controls .btn_save'))
    },
    initGooleMapApi () {
      loadGoogleMapsApi({
        // key: 'AIzaSyBbBLwQZwwlbh5awTENmr9zcGJA_8_GDMs',
        key: 'AIzaSyAhsDrOGbvQO7C-GeXkrDCplL9DFyrcirE',
        language: this.$i18n.locale,
        libraries: []
      })
        .then((googleMaps) => {
          this.gm = googleMaps
          this.initMap()
          this.initMapEvents()
          this.initInfoWindow()
          this.initConsrolSearchInputAndPointBtn()
          this.initControlBtnSave()
          this.initGeocoder()
          this.setMarker()
          this.setMarkerEvents()
        }).catch(function (error) {
          console.error(error)
        })
    },
    saveData () {
      const data = {
        address: this.searchQuery,
        lat: this.markerPosition.lat,
        lng: this.markerPosition.lng
      }

      this.$emit('input', data)
      this.showModal = false
    },
    computeHeights () {
      // const header = document.querySelector('.modal-header-input')
      // if (header) {
      //   this.headerHeight = header.clientHeight + parseInt(getComputedStyle(document.documentElement).getPropertyValue('--sat'))
      // }
    }
  },

  watch: {
    showModal (val) {
      if (val) {
        this.$nextTick(() => {
          this.computeHeights()
          this.setStartCoord()
          this.initGooleMapApi()
        })

        // setTimeout(() => {
        //   this.$refs.autocompleteModalInput.focus()
        // }, 200)
      }
    },

    async searchQuery (val) {
      if (this.isPlaceSelected) {
        setTimeout(() => {
          this.isPlaceSelected = false
        }, 200)
      } else if (val && val.length) {
        const { data } = await this.$apollo.query({
          query: PlaceAutocompleteGQL,
          variables: {
            input: val
          }
        })

        this.places = data.commonData.PlaceAutocomplete.predictions.map(place => place.description)
      }

      clearTimeout(timeout)
      timeout = setTimeout(() => {
        this.geocodeAddress()
      }, 400)
    },

    'screen.height' () {
      this.computeHeights()
    }
  }
}
</script>

<style lang="scss">
  .add-shop-map {
    &__list {
      position: absolute;
      left: 0;
      height: unset;
      width: 100%;
      border-top: 1px solid $color-grey-lighten;
      background-color: $color-white;
      z-index: 1;

      @include respond(tab-port) {
        height: unset;
      }

      &-item {
        padding: 1.5rem 2rem;
        cursor: pointer;

        @media(hover: hover) and (pointer: fine) {
          &:hover {
            background-color: darken($color-grey-lighten, 1%);
          }
        }

        &:active {
          background-color: darken($color-grey-lighten, 1%);
        }
      }
    }
  }
</style>
